/**
 * Api request ordering
 */
export class ApiRequestOrdering {
	columnName?: string;
	direction?: 'ASC' | 'DESC';
}
